const translation = {
  toVerifiedTip: {
    end: 'Dify 프로페셔널 플랜을 위해.',
    coupon: '독점 100% 쿠폰',
    front: '당신은 이제 교육 인증 상태를 받을 자격이 있습니다. 아래에 귀하의 교육 정보를 입력하여 과정을 완료하고 인증을 받으십시오.',
  },
  form: {
    schoolName: {
      placeholder: '귀하의 학교의 공식 약어가 아닌 전체 이름을 입력하세요.',
      title: '당신의 학교 이름',
    },
    schoolRole: {
      option: {
        teacher: '교사',
        student: '학생',
        administrator: '학교 관리자',
      },
      title: '당신의 학교 역할',
    },
    terms: {
      desc: {
        end: '제출함으로써：',
        and: '와',
        termsOfService: '서비스 약관',
        front: '귀하의 정보 및 교육 인증 상태 사용은 우리의',
        privacyPolicy: '개인정보 보호정책',
      },
      option: {
        inSchool: '나는 제공된 기관에 재학 중이거나 고용되어 있음을 확인합니다. Dify 는 재학증명서나 고용증명서를 요청할 수 있습니다. 만약 내가 자격을 허위로 진술하면, 나는 내 교육 상태에 따라 처음 면제된 수수료를 지불하기로 동의합니다.',
        age: '나는 최소한 18 세 이상임을 확인합니다.',
      },
      title: '약관 및 동의사항',
    },
  },
  submit: '제출',
  rejectContent: '안타깝게도, 귀하는 교육 인증 상태에 적합하지 않으므로 이 이메일 주소를 사용할 경우 Dify Professional Plan 의 독점 100% 쿠폰을 받을 수 없습니다.',
  successContent: '귀하의 계정에 Dify Professional 플랜을 위한 100% 할인 쿠폰을 발급했습니다. 이 쿠폰은 1 년간 유효하므로 유효 기간 내에 사용해 주시기 바랍니다.',
  currentSigned: '현재 로그인 중입니다',
  toVerified: '교육 인증 받기',
  rejectTitle: '귀하의 Dify 교육 인증이 거부되었습니다.',
  learn: '교육 인증을 받는 방법을 배우세요',
  submitError: '양식 제출에 실패했습니다. 나중에 다시 시도해 주세요.',
  successTitle: '당신은 Dify 교육 인증을 받았습니다.',
  emailLabel: '현재 이메일',
}

export default translation
